<template>
  <div class="rd-fbar ui-bar">
    <ui-segment v-for="seg in segments" :key="seg.id" :value="seg.value" :options="seg.options" :label="seg.label" @input="(value) => $emit('segment', seg.id, value)" />
    <ui-search ref="search" :value="query" :placeholder="placeholder" :label="searchLabel" @input="$emit('query', $event)" />
    <span class="ui-bar__spacer"></span>
    <span class="ui-bar__count ui-num">{{ count }}</span>
  </div>
</template>

<script>
/**
 * Traka filtera iznad liste: jedan ili više segmenata, pretraga i brojač ("12 od 30").
 * segments: [{ id, label, value, options: [{ value, label }] }]; izbor se ne čuva ovdje, već se javlja (segment, query).
 * Ljuska izvještaja traži ref "bar" i metodu focusSearch() (prečica "/").
 */
export default {
  name: "UiFilterBar",
  props: {
    segments: { type: Array, default: () => [] },
    query: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    searchLabel: { type: String, default: "" },
    count: { type: String, default: "" },
  },
  methods: {
    focusSearch() {
      this.$refs.search.focus();
    },
  },
};
</script>
